<template>
  <g
    class="plan-desk" :class="{ 'plan-desk--dimmed': dimmed && !selected, 'plan-desk--selected': selected }"
    :data-desk-id="geometry.id" role="button" tabindex="0" :aria-label="label" :aria-pressed="String(selected)"
    @pointerenter="$emit('hover', $event)" @pointerleave="$emit('unhover', $event)"
    @click="$emit('activate', $event)" @keydown.enter.prevent.stop="$emit('activate', $event)"
    @keydown.space.prevent.stop="$emit('activate', $event)"
  >
    <component :is="geometry.tag" v-bind="geometry.attributes" :transform="geometry.transform"
      class="plan-desk-shape" :fill="color" vector-effect="non-scaling-stroke" />
  </g>
</template>

<script>
export default {
  props: {
    geometry: { type: Object, required: true },
    color: String, label: String, selected: Boolean, dimmed: Boolean
  }
};
</script>

<style scoped>
.plan-desk { cursor: pointer; outline: none; }
.plan-desk-shape { stroke: #343b3d; stroke-width: 1; stroke-linejoin: round; }
.plan-desk--dimmed { opacity: 0.18; }
.plan-desk:hover .plan-desk-shape, .plan-desk:focus .plan-desk-shape, .plan-desk--selected .plan-desk-shape { stroke: #ec651e; stroke-width: 3; }
</style>
